export function animateValue(
  startValue,
  endValue,
  updateFn,
  completeFn,
  duration = 300,
  easingType = 'cubic',
) {
  if (startValue === endValue) {
    updateFn(endValue);
    if (completeFn) completeFn();
    return null;
  }

  const startTime = performance.now();
  let animationId;
  let lastValue = null;

  const easing = {
    linear: progress => progress,
    cubic: progress => 1 - Math.pow(1 - progress, 3),
    elastic: progress => {
      const p = progress - 1;
      return 1 + p * p * p * (26 * p * p + 46 * p + 26);
    },
    bounce: progress => {
      const n1 = 7.5625;
      const d1 = 2.75;

      if (progress < 1 / d1) {
        return n1 * progress * progress;
      } else if (progress < 2 / d1) {
        const p = progress - 1.5 / d1;
        return n1 * p * p + 0.75;
      } else if (progress < 2.5 / d1) {
        const p = progress - 2.25 / d1;
        return n1 * p * p + 0.9375;
      } else {
        const p = progress - 2.625 / d1;
        return n1 * p * p + 0.984375;
      }
    },
  };

  const step = currentTime => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easing[easingType](progress);

    const currentValue = startValue + (endValue - startValue) * easedProgress;

    if (lastValue === null || Math.abs(currentValue - lastValue) > 0.01) {
      updateFn(currentValue);
      lastValue = currentValue;
    }

    if (progress < 1) {
      animationId = requestAnimationFrame(step);
    } else {
      if (lastValue !== endValue) {
        updateFn(endValue);
      }
      if (completeFn) completeFn();
    }
  };

  animationId = requestAnimationFrame(step);
  return animationId;
}

export function cancelAnimation(animationId) {
  if (animationId) {
    cancelAnimationFrame(animationId);
  }
}
